import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {inject, Injectable, Injector} from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '../services/toast.service';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403) {
          const translateService = this.injector.get(TranslateService);
          const toastService = this.injector.get(ToastService);
          toastService.showMessage({
            severity: 'error',
            summary: translateService.instant('forbidden.title'),
            detail: translateService.instant('forbidden.detail'),
          });
        }
        return throwError(() => error);
      })
    );
  }
}